module.exports = __webpack_public_path__ + "146b452258ff66ad6733a37e834b66a4.ico";